import axios from 'axios';
import qs from 'qs';
import { GLOW_API_URL } from './config';
import { applyAuthRefresh, applyGlowHeaders } from './interceptors';
import { returnRequest } from './request';

const createClient = () =>
  axios.create({
    baseURL: GLOW_API_URL,
    timeout: 30000,
    paramsSerializer: {
      serialize: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    },
  });

/** /app/** — 회원(또는 게스트) 토큰을 싣는다. 401 이면 토큰 갱신 후 1회 재시도 */
export const glowClient = createClient();
/** /public/** — 토큰 없이 언어·통화·게스트 헤더만 싣는다 */
export const publicGlowClient = createClient();
/** 공개 지역 metadata — 회원 Bearer와 Guest 헤더를 모두 제외한다. */
const anonymousGlowClient = createClient();

applyGlowHeaders(glowClient, { includeAuth: true });
applyAuthRefresh(glowClient);
applyGlowHeaders(publicGlowClient, { includeAuth: false });
applyGlowHeaders(anonymousGlowClient, {
  includeAuth: false,
  includeGuestHeader: false,
});

export const glowRequest = returnRequest(glowClient);
export const publicGlowRequest = returnRequest(publicGlowClient);
export const anonymousGlowRequest = returnRequest(anonymousGlowClient);

export { default as AppError } from './AppError';
export * from './types';
export { GLOW_API_URL, HEADER } from './config';
